export const getTenantsList = (state) => state.tenantsList
